// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/terminal-control-areas.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/terminal-control-areas/terminal-control-areas.js';

mount([g0]);
